import * as React from 'react';
import { Button } from '../Bootstrap';
import { NobleModal } from '../NobleModal';
import { DateRange } from './types';
import { DatePicker } from './DatePicker';

interface DatePickerModalProps {
  isOpen: boolean;
  selected: DateRange;
  toggle();
  update(start: Date, end: Date);
}

export const DatePickerModal = (props: DatePickerModalProps) => {
  const { isOpen, selected, toggle, update } = props;
  const [range, setRange] = React.useState<DateRange>(selected);

  React.useEffect(() => {
    setRange(selected);
  }, [selected]);

  const onClickUpdate = React.useCallback(() => {
    update(range.start, range.end);
  }, [update, range]);

  const onSelect = React.useCallback(
    ({ start, end }) => {
      setRange({ start, end });
    },
    [setRange]
  );

  return (
    <NobleModal
      hideCloseIcon={true}
      className='modal-dialog-centered date-picker-modal'
      size='lg'
      isOpen={isOpen}
      toggle={toggle}
    >
      <NobleModal.Title title='Select period' />
      <div>
        <Button type='button' color='link' className='date-picker-modal-cancel' onClick={toggle}>
          Cancel
        </Button>
        <Button type='button' color='link' className='date-picker-modal-update' onClick={onClickUpdate}>
          Update
        </Button>
      </div>
      <NobleModal.Body>
        <DatePicker selected={props.selected} onSelect={onSelect} />
      </NobleModal.Body>
    </NobleModal>
  );
};
